<template>
	<popup title="Delete step" @close="closePopup" medium>
		<template v-slot:content>
			<div class="__content">
				<label class="form_steps_label step_1" :class="{'active': (checkboxModel1 && checkboxModel2)}">
					<span class="icon"></span> Are you sure?
				</label>
				<div class="brdr_content_wrpr">
					<h3 class="brdr_content_title">I Understand that this will delete:</h3>
					<v-switch v-model="checkboxModel1" >My funnel step <b>[{{step.name}}]</b> and all its settings.</v-switch>
					<v-switch :label="`All its products.`" v-model="checkboxModel2" />
				</div>
			</div>
		</template>

		<template v-slot:actions>
			<v-button @click="removeStep" label="Delete"
			          :loading="saving"
			          red border :disabled="!(checkboxModel1 && checkboxModel2)" />
			<v-button label="Cancel" @click="closePopup" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import VSwitch from "@/components/base/v-switch";
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";

export default {
    name: "delete-step-popup",
	components: {VButton, Popup, VSwitch},
	props:['funnelId','stepId','step'],
    mixins: [API],
    data() {
        return {
	        saving:false,
          checkboxModel1: false,
          checkboxModel2: false,
        }
    },
    computed:{
    },
    methods: {
        closePopup() {
          this.$emit('close')
        },
        async removeStep() {
					try {
						this.saving=true;

						let result = await this.api.wsteps.delete(parseInt(this.funnelId), parseInt(this.stepId));
						if (result.error)
							throw result
						this.$store.dispatch('REMOVE_STEP', this.stepId);
						this.$router.push({path: `/wfunnel/${this.funnelId}`});
						this.$emit('done')
					}catch (e) {
						this.$error(e)
					} finally {
						this.saving=false;
					}
        },
    },
}
</script>

<style lang="scss" scoped>
.__content {
	margin: 10px 0;
}
</style>
